import { memo } from 'react'
import { isEqual } from 'lodash'
import { PageTitle } from 'app/components/common/PageTitle'
import R from 'app/assets/R'
import { useTranslation } from 'react-i18next'
import VoucherManagementContainer from 'app/containers/Marketing/VoucherManagement'

const VoucherManagementPageCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.voucher_management)}</PageTitle>
      <VoucherManagementContainer />
    </>
  )
}
const VoucherManagementPage = memo(
  VoucherManagementPageCpn,
  isEqual,
)

export default VoucherManagementPage
